<template>
  <div>
    <div class="mb-4" v-html="$t('tan.text')"></div>

    <b-form-group>
      <b-form-text>{{ $t("tan.label") }}</b-form-text>
      <b-form-input
        ref="formTanTan"
        maxlenght="12"
        v-model="data.tan"
        @input="inputHandler"
        @keyup="enterHandler"
        autofocus
      />
      <b-form-invalid-feedback :state="!(errorCode === 1)">{{
        $t("tan.tanRequired")
      }}</b-form-invalid-feedback>
      <b-form-invalid-feedback :state="!(errorCode === 2)">{{
        $t("tan.tanInvalid")
      }}</b-form-invalid-feedback>
    </b-form-group>

    <!--<hr class="mt-5" />-->
    <b-form-group class="mt-5">
      <b-button class="float-right" @click="nextHandler">{{
        $t("tan.next")
      }}</b-button>
    </b-form-group>
  </div>
</template>

<script>
import ModTan from "../modules/ModTan"

export default {
  name: "FormTan",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      data: this.value,
      errorCode: 0,
    }
  },
  methods: {
    enterHandler(evt) {
      if(evt.keyCode === 13) {
        this.nextHandler()
      }
    },  
    inputHandler() {
      this.$emit("input", this.data)
      this.errorCode = 0
    },
    async validate() {
      if (!this.data.tan) {
        this.errorCode = 1
        this.$refs.formTanTan.focus()
        return null
      } else {
        this.data.tan = this.data.tan.trim()
      }
      if (
        !(await ModTan.validate(
          this.data.tan,
          this.$specs.accountId,
          this.$specs.projectId
        ))
      ) {
        this.errorCode = 2
        this.$refs.formTanTan.select()
        this.$refs.formTanTan.focus()
        return null
      }
      return this.data
    },
    async nextHandler() {
      if (await this.validate()) {
        this.$emit("next", this.data)
      }
    },
  },
  watch: {
    value(val) {
      this.data = val ? val : {}
    },
  },
}
</script>